import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { PostForecastForReceiptAdapter } from '../adapter/postForecastForReceiptAdapter';
import { IForecastForReceiptRepository } from '@/coreInfrastructureModule/interfaces/IForecastForReceiptManage';
import { ForecastForReceiptFormState } from '../domains/entities/ForecastForReceiptMenu';

/**
 * 受領用内示を新たに作成するUseCase
 */
export class CreateForecastForReceiptUseCase {
  private repository: IForecastForReceiptRepository;

  /**
   * @param repository - 受領用内示情報の永続化の責務を負うクラス
   */
  constructor(repository: IForecastForReceiptRepository) {
    this.repository = repository;
  }

  /**
   * 受領用内示を新たに作成する
   * @param newForecastForReceiptInfo - 新たに作成する受領用内示の情報
   */
  public Execute = async (newForecastForReceiptInfo: ForecastForReceiptFormState): Promise<INetworkResult<void, Error>> => {
    try {
      const request = PostForecastForReceiptAdapter.adaptForRequest(newForecastForReceiptInfo);
      const result = await this.repository.postForecastForReceipt(request);

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }

      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('作成に失敗しました'),
        },
      };
    }
  };
}
